import {ToadMensagemService} from './../../service/toad-mensagem.service';
import {NgForm} from '@angular/forms';
import {Dependencia, Evento} from './../../model/catalogo';
import {Component, OnInit, Output, EventEmitter, Input, DoCheck} from '@angular/core';

@Component({
    selector: 'app-cadastro-dependencia',
    templateUrl: './cadastro-dependencia.component.html',
    styleUrls: ['./cadastro-dependencia.component.css']
})

export class CadastroDependenciaComponent implements OnInit, DoCheck {

    dependencia: Dependencia = new Dependencia();

    evento: Evento = new Evento();

    eventosAnteriores: Array<Evento> = new Array<Evento>();

    @Output() dependenciaAdicionada = new EventEmitter();

    @Output() eventoQtdSegundosMaxEntreEventos = new EventEmitter();

    @Input() newListaDependencia: any;

    @Input() newQtdSegundosMaxEntreEvento: any;

    @Input() arrayEvento: any;

    @Input() eventoAtual: any;

    quantidade: any;

    listaDependencias: Array<Dependencia> = new Array<Dependencia>();

    chaveComposta: any;

    constructor(private messageService: ToadMensagemService) {
    }

    ngOnInit() {
    }

    // Um método de retorno uma chamada que executa a detecção de alterações
    ngDoCheck(): void {

        if (this.newQtdSegundosMaxEntreEvento != undefined) {
            this.quantidade = this.newQtdSegundosMaxEntreEvento;
            this.evento.qtdSegundosMaxEntreEventos = this.quantidade;
            this.eventoQtdSegundosMaxEntreEventos.emit(this.evento);
        }

        if (this.arrayEvento != undefined && this.eventoAtual != undefined) {
            this.eventosAnteriores = [];
            for (let i in this.arrayEvento) {
                if (this.arrayEvento[i].etapa != this.eventoAtual.etapa) {

                    this.eventosAnteriores.push(this.arrayEvento[i]);
                }
            }
        }

        if (this.newListaDependencia != undefined || this.newListaDependencia != null) {
            this.listaDependencias = new Array<Dependencia>();

            this.listaDependencias = this.newListaDependencia;

            this.dependenciaAdicionada.emit(this.listaDependencias);
        }
    }

    adicionarQtdSegMax() {
        this.quantidade = this.evento.qtdSegundosMaxEntreEventos;
        this.eventoQtdSegundosMaxEntreEventos.emit(this.evento);
    }


    adicionarDependencia() {

        this.listaDependencias.push(this.dependencia);

        this.dependencia = new Dependencia();

        this.dependenciaAdicionada.emit(this.listaDependencias);

        this.eventoQtdSegundosMaxEntreEventos.emit(this.evento);

    }

    // limpa formulario
    onSubmit(f: NgForm) {
        f.reset();
    }

    // método usado para editar dependência
    onRowSelectDependencia(item) {

        this.dependencia.eventoAnterior = item.eventoAnterior;
        this.dependencia.codRetornoMin = item.codRetornoMin;
        this.dependencia.codRetornoMax = item.codRetornoMax;

        this.removerDependencia(item);

    }

    removerDependencia(indice: any) {

        const index = this.listaDependencias.indexOf(indice);

        this.listaDependencias.splice(index, 1);

    }

}



// WEBPACK FOOTER //
// ./src/app/cadastro-dependencia/cadastro-dependencia.component.ts